export default function onlyNumber(this: any, $event: any){
  const keyCode = $event.keyCode ? $event.keyCode : $event.which;
  if (
    (keyCode < 48 || keyCode > 57) && (keyCode !== 46 || this.price.indexOf('.') !== -1)
  ){
    // 46 is dot
    $event.preventDefault();
  }
}
